var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"preview-container"},[(_vm.fileUrl)?_c('embed',{staticClass:"preview-embed",attrs:{"src":_vm.fileUrl}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }